<template>
    <div class="work_order_config">
        <div class="header">
            <div class="left">{{ $t('channel.workOrderConfig') }}</div>
            <div class="saveBtn" @click="save">
                <i class="guoran-tongyichicun-16-03-baocun iconfont"></i>
                {{ $t('channel.save') }}
            </div>
        </div>
        <div class="work_order_content">
            <div class="work_order_list_head" v-if="workOrderEntryList.length > 0">
                <div class="work_order_title">工单入口名称</div>
                <div class="work_order_template">默认模板</div>
                <div class="work_order_id">入口ID</div>
                <div class="work_order_action">操作</div>
            </div>
            <div class="drop_content" ref="dropContent">
                <div v-for="(item, index) in workOrderEntryList" :key="index" class="work_order_item">
                    <div class="work_order_item_content">
                        <div class="work_order_item_name">
                            <el-input 
                                v-model="item.name" 
                                size="small"
                                :placeholder="$t('common.placeholder')"
                                maxlength="50"
                            ></el-input>
                        </div>
                        <div class="work_order_item_template">
                            <el-select 
                                v-model="item.templateId" 
                                size="small"
                                :placeholder="$t('common.placeholder')"
                                filterable
                                style="width: 100%"
                                @change="handleTemplateChange(item)"
                            >
                                <el-option-group
                                    v-for="group in templateList"
                                    :key="group.id"
                                    :label="group.name"
                                >
                                    <el-option
                                        v-for="template in group.children"
                                        :key="template.id"
                                        :label="template.name"
                                        :value="template.id"
                                    >
                                    </el-option>
                                </el-option-group>
                            </el-select>
                        </div>
                        <div class="work_order_item_id">
                            <span v-if="item.id" class="id-text">{{ item.id }}</span>
                            <span v-else class="id-empty">--</span>
                        </div>
                    </div>
                    <div class="work_order_item_right">
                        <i class="iconfont guoran-a-16-09" @click="deleteWorkOrderEntry(index)"></i>
                    </div>
                </div>
            </div>

            <div class="work_order_add" @click="addWorkOrderEntry">
                <div class="work_order_add_icon">
                    <i class="el-icon-plus"></i>
                </div>
                <span>添加工单入口</span>
            </div>
        </div>
    </div>
</template>

<script>
import { requestUrl } from "../../../api/requestUrl";
export default {
    name: "workOrderConfig",
    props: {
        bindDetail: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            workOrderEntryList: [],
            templateList: [],
            loading: false
        };
    },
    mounted() {
        this.getTemplateList();
        this.initWorkOrderEntryList();
    },
    methods: {
        // 获取工单模板列表
        async getTemplateList() {
            try {
                const mainId = localStorage.getItem('_mainId');
                const userId = localStorage.getItem('_uid');
                
                if (!mainId || !userId) {
                    this.$message.error('获取用户信息失败，请重新登录');
                    return;
                }

                const res = await this.$http.get(requestUrl.workOrder.getTemplateList, {
                    params: {
                        mainId: mainId,
                        userId: userId,
                        countOrder: true
                    }
                });
                
                if (res.data.code == 0 || res.data.code === "0") {
                    // 处理接口返回的数据结构
                    // 接口返回: [{ children: [{ id, name, ... }] }]
                    const data = res.data.data || [];
                    this.templateList = data.map((group, index) => {
                        // 如果分组本身有 id 和 name，使用它们；否则使用索引
                        return {
                            id: group.id || `group_${index}`,
                            name: group.name || `分组${index + 1}`,
                            children: group.children || []
                        };
                    });
                }
            } catch (error) {
                console.error('获取工单模板列表失败:', error);
                this.$message.error('获取工单模板列表失败');
            }
        },
        // 初始化工单入口列表
        async initWorkOrderEntryList() {
            // 从后端获取已配置的工单入口
            try {
                if (!this.bindDetail.bindCode) {
                    console.warn('bindCode不存在，无法查询工单入口列表');
                    return;
                }

                const res = await this.$http.get(requestUrl.workOrder.getWorkOrderEntryList, {
                    params: {
                        bindCode: this.bindDetail.bindCode
                    }
                });
                
                // 兼容字符串 "0" 和数字 0
                if ((res.data.code == 0 || res.data.code === "0") && res.data.data) {
                    this.workOrderEntryList = Array.isArray(res.data.data) 
                        ? JSON.parse(JSON.stringify(res.data.data))
                        : [];
                } else if (res.data.code != 0 && res.data.code !== "0") {
                    console.error('获取工单入口列表失败:', res.data.message);
                }
            } catch (error) {
                console.error('获取工单入口列表失败:', error);
                // 如果接口不存在或失败，从 bindDetail 中获取（兼容旧数据）
                if (this.bindDetail.workOrderEntryList && Array.isArray(this.bindDetail.workOrderEntryList)) {
                    this.workOrderEntryList = JSON.parse(JSON.stringify(this.bindDetail.workOrderEntryList));
                }
            }
        },
        // 添加工单入口
        addWorkOrderEntry() {
            this.workOrderEntryList.push({
                name: '',
                templateId: ''
            });
        },
        // 删除工单入口
        deleteWorkOrderEntry(index) {
            this.$confirm('确定要删除这个工单入口吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 从列表中移除该项，保存时会全量覆盖，后端会自动删除未提交的记录
                this.workOrderEntryList.splice(index, 1);
            }).catch(() => {});
        },
        // 处理模板选择变化，自动填充模板名称
        handleTemplateChange(item) {
            // 从模板列表中找到对应的模板并填充 templateName
            for (const group of this.templateList) {
                const template = group.children.find(t => t.id === item.templateId);
                if (template) {
                    this.$set(item, 'templateName', template.name);
                    break;
                }
            }
        },
        // 保存
        // 全量覆盖式保存逻辑：
        // 1. 新增：提交数组里元素不带 id 即视为新建
        // 2. 修改：带上已有记录的 id，同时更新其它字段
        // 3. 删除：不再传某条记录的 id（提交列表里不包含它），服务端会将该记录标记删除
        // 4. 清空：若传空数组则清空该渠道下全部工单入口
        async save() {
            // 验证必填项
            for (let i = 0; i < this.workOrderEntryList.length; i++) {
                const item = this.workOrderEntryList[i];
                if (!item.name || !item.name.trim()) {
                    this.$message.warning(`第${i + 1}个工单入口的名称不能为空`);
                    return;
                }
                if (!item.templateId) {
                    this.$message.warning(`第${i + 1}个工单入口的默认模板不能为空`);
                    return;
                }
            }

            // 过滤掉空项，validEntries 即为要保存的完整列表
            // 不在这个列表中的项（之前有 id 但现在被删除的）会被后端自动删除
            const validEntries = this.workOrderEntryList.filter(item => 
                item.name && item.name.trim() && item.templateId
            );

            // 调用保存接口，将 validEntries 保存到后端
            try {
                if (!this.bindDetail.bindCode) {
                    this.$message.error('bindCode不存在，无法保存');
                    return;
                }

                // 准备保存数据
                // 全量覆盖式保存：提交当前页面上的所有有效项
                // - 有 id 的项：带上 id，后端会更新该记录
                // - 没 id 的项：不带 id，后端会新增记录
                // - 不在列表中的项：不提交，后端会自动删除
                // - 空数组：提交空数组，后端会清空该渠道下所有工单入口
                const saveData = validEntries.map(item => {
                    const entry = {
                        name: item.name.trim(),
                        templateId: item.templateId
                    };
                    
                    // 如果已有 id，带上 id 表示更新；否则表示新增
                    if (item.id) {
                        entry.id = item.id;
                    }
                    
                    // 可选字段：templateName（用于展示）
                    if (item.templateName) {
                        entry.templateName = item.templateName;
                    }
                    // 可选字段：orderNum（排序号）
                    if (item.orderNum !== undefined) {
                        entry.orderNum = item.orderNum;
                    }
                    return entry;
                });

                // 调用保存接口，在 Query 中显式携带 bindCode
                // 后端会根据全量覆盖逻辑处理：新增、修改、删除
                const res = await this.$http.post(requestUrl.workOrder.saveWorkOrderEntry, saveData, {
                    params: {
                        bindCode: this.bindDetail.bindCode
                    }
                });
                
                // 兼容字符串 "0" 和数字 0
                if (res.data.code == 0 || res.data.code === "0") {
                    this.$message.success('保存成功');
                    // 重新获取列表以更新 id 等信息（新增的项会获得 id）
                    await this.initWorkOrderEntryList();
                    this.$emit('saveSuccess', validEntries);
                } else {
                    this.$message.error(res.data.message || '保存失败');
                }
            } catch (error) {
                console.error('保存失败:', error);
                this.$message.error('保存失败');
            }
        }
    }
};
</script>

<style scoped lang="less">
.work_order_config {
    .header {
        margin-bottom: 14px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .left {
            font-size: 16px;
            color: #000000;
        }

        .saveBtn {
            height: 26px;
            background-color: #366aff;
            color: #FFFFFF;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0 14px;
            font-size: 12px;
            border-radius: 17px;
            cursor: pointer;

            i {
                font-size: 12px;
                padding-right: 4px;
            }
        }
    }

    .work_order_content {
        .work_order_list_head {
            display: flex;
            align-items: center;
            padding: 12px 0;
            border-bottom: 1px solid #E4E7ED;
            margin-bottom: 12px;

            .work_order_title {
                flex: 1;
                font-size: 14px;
                color: #606266;
                font-weight: 500;
            }

            .work_order_template {
                flex: 1;
                font-size: 14px;
                color: #606266;
                font-weight: 500;
                margin-left: 20px;
            }

            .work_order_id {
                width: 120px;
                flex: none;
                font-size: 14px;
                color: #606266;
                font-weight: 500;
                margin-left: 20px;
            }

            .work_order_action {
                width: 60px;
                flex: none;
                font-size: 14px;
                color: #606266;
                font-weight: 500;
                text-align: right;
            }
        }

        .drop_content {
            .work_order_item {
                display: flex;
                align-items: center;
                padding: 12px 0;
                border-bottom: 1px solid #F0F0F0;
                position: relative;

                .work_order_item_content {
                    flex: 1;
                    display: flex;
                    align-items: center;
                    gap: 20px;

                    .work_order_item_name {
                        flex: 1;
                        min-width: 200px;
                    }

                    .work_order_item_template {
                        flex: 1;
                        min-width: 200px;
                    }

                    .work_order_item_id {
                        width: 120px;
                        flex: none;
                        font-size: 14px;
                        color: #606266;
                        margin-left: 20px;

                        .id-text {
                            color: #606266;
                        }

                        .id-empty {
                            color: #C0C4CC;
                        }
                    }
                }

                .work_order_item_right {
                    width: 20px;
                    margin-left: 12px;
                    cursor: pointer;

                    i {
                        color: #909399;
                        font-size: 16px;

                        &:hover {
                            color: #F56C6C;
                        }
                    }
                }
            }
        }

        .work_order_add {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 20px 0;
            margin-top: 12px;
            border: 1px dashed #DCDFE6;
            border-radius: 4px;
            cursor: pointer;
            color: #606266;
            transition: all 0.3s;

            &:hover {
                border-color: #366aff;
                color: #366aff;
            }

            .work_order_add_icon {
                width: 20px;
                height: 20px;
                border-radius: 50%;
                background-color: #F0F0F0;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-right: 8px;

                i {
                    font-size: 14px;
                    color: #909399;
                }
            }

            span {
                font-size: 14px;
            }
        }
    }
}
</style>

